/** Prevent an older async request from publishing state after a newer one starts or its owner unmounts. */
export function createLatestRequestGuard() {
  let generation = 0
  return {
    start(): () => boolean {
      const request = ++generation
      return () => request === generation
    },
    invalidate(): void {
      generation++
    },
  }
}
